import React, { useContext } from "react";
import "./Certifications.scss";
import { Fade } from "react-reveal";
import {certifications} from "../../portfolio";

import CertificationCard from "../../components/certificationCard/CertificationCard";
import StyleContext from "../../contexts/StyleContext";

export default function Certifications() {
    const {isDark} = useContext(StyleContext);
    return (
      <div className="main" id="achievements">
        <Fade bottom duration={1000} distance="20px">
          <h1 className="component-heading">{certifications.title}</h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle achievement-subtitle"
                  : "subTitle component-subtitle"
              }
            >
              {certifications.subtitle}
            </p>
        </Fade>
        <Fade bottom>
        <div className="certs-body-div">
          {certifications.certifications.map((cert) => {
            return <CertificationCard certificate={cert}  />;
          })}
        </div>
        </Fade>
      </div>
    );
  
}

